import React, { useState } from "react";

// useForm START
export default function useForm(initializeValue) {
  const [values, setValues] = useState(initializeValue);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setValues({
        ...values,
        [name]: checked,
      });
    } else {
      setValues({
        ...values,
        [name]: value,
      });
    }
  };

  const resetForm = () => {
    setValues(initializeValue);
  };

  return {
    values,
    setValues,
    handleInputChange,
    resetForm,
  };
}
// useForm END

// Form Component START
export function Form({ className, children, ...others }) {
  return (
    <form className={className} {...others}>
      {children}
    </form>
  );
}
// Form Component END
